export default __webpack_public_path__ + "static/media/about.a4c00c3f.png";